































































































































import { Component, Vue } from 'vue-property-decorator'
import fetch from '@/utils/fetch'
import moment from 'moment'
import { AgencyController, SchoolController } from '@/services/request.service'
import { resource } from '@/router'
import { saveAs } from 'file-saver'

@Component
export default class ViewDistributor extends Vue {
  private distributor: any = {}
  private mibpData: Array<any> = []
  private schoolData: Array<any> = []
  private schoolLoading = false
  private descriptionExpand = false

  private moment = moment

  private get locale(): string {
    return this.$store.state.locale
  }

  private get mibpColumns(): Array<any> {
    return [
      {
        title: this.$tc('distributorMgmt.section'),
        dataIndex: 'sectionName',
      },
      {
        title: this.$tc('distributorMgmt.bookSeries'),
        scopedSlots: {
          customRender: 'bookSeries',
        },
      },
      {
        title: this.$tc('distributorMgmt.subscribedNum'),
        dataIndex: 'orderNum',
      },
    ]
  }

  private get schoolColumns(): Array<any> {
    return [
      {
        title: this.$tc('schoolMgmt.schoolCode'),
        dataIndex: 'code',
      },
      {
        title: this.$tc('schoolMgmt.schoolName'),
        scopedSlots: {
          customRender: 'schoolName',
        },
      },
      {
        title: this.$tc('schoolMgmt.teacherNum'),
        dataIndex: 'teacherNum',
      },
      {
        title: this.$tc('schoolMgmt.studentNum'),
        dataIndex: 'studentNum',
      },
      {
        title: this.$tc('schoolMgmt.status'),
        scopedSlots: {
          customRender: 'status',
        },
      },
    ]
  }

  private created(): void {
    this.getDistributorInfo()
    this.getSchools()
  }

  private toggleDescriptionExpand(): void {
    this.descriptionExpand = !this.descriptionExpand
  }

  private getDistributorInfo(): void {
    const distributorId = parseInt(this.$route.params.distributorId, 10)
    AgencyController.detail(distributorId)
      .then(res => {
        const features = res.data.features.map(feature => feature.featureName).join('、')
        const contracts = res.data.resources.map(resource => resource.resourceName).join('、')
        this.distributor = {
          ...res.data,
          featuresText: features.length > 30 ? features.slice(0, 30) + '...' : features,
          contractsText: contracts.length > 30 ? contracts.slice(0, 30) + '...' : contracts,
        }
        this.mibpData = res.data.pictureBooks.map((book, index) => {
          return {
            ...book,
            index,
          }
        })
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private getSchools(page = {}): void {
    this.schoolLoading = true
    const request = {
      pageCurrent: 1,
      pageSize: 0,
      agencyId: parseInt(this.$route.params.distributorId, 10),
      forAgency: false,
      ...page,
    }
    SchoolController.getPageList(request)
      .then(res => {
        this.schoolData = res.data.items
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.schoolLoading = false
      })
  }

  private schoolDetail(schoolId): void {
    this.$router.push({ name: 'viewSchool', params: { schoolId } })
  }

  private download(resourceUrl, resourceName): void {
    saveAs(resourceUrl, resourceName)
  }
}
